<agpr-dialog-container
    [id]="id"
    class="ghostIn-dialogContainer"
    heading="Core.ghostIn.header"
    (close)="closeDialog()"
    [contentPadding]="false"
    [formGroup]="ghostInForm"
    [agprLoading]="loading"
    [agprGlobalLoading]="true"
>
    <div class="ghostIn-content">

        <div class="ghostIn-info">
            {{ 'Core.ghostIn.body' | localize }}
        </div>

        <div class="ghostIn-input">
            <agpr-text-input
                formControlName="username"
                [id]="id + '-emailInput'"
                header="Core.ghostIn.inputLabel"
                placeholder="Core.ghostIn.placeholder"
                tooltip="Core.ghostIn.tooltip"
                tooltipPosition="top"
                ariaDescribedBy="email_errors"
                [ariaInvalid]="username.errors?.['email'] || username.errors?.['invalidGhostIn']"
                [bottomMargin]="false"
            ></agpr-text-input>
            <ul id="email_errors">
                <li *ngIf="invalidGhostIn">
                    <agpr-form-message>
                        {{ "Core.ghostIn.error.invalidGhostIn" | localize }}
                    </agpr-form-message>
                </li>
                <li *ngIf="username.errors?.['email'] && showErrorMessages">
                    <agpr-form-message>
                        {{ "Core.ghostIn.error.emailFormat" | localize }}
                    </agpr-form-message>
                </li>
            </ul>
        </div>
    </div>
    <ng-template #footerLeft>
        <agpr-button
            [id]="id + '-cancelBtn'"
            label="Core.button.cancel"
            (click)="closeDialog()"
            [style]="buttonTypesEnum.secondary"
        ></agpr-button>
    </ng-template>
    <ng-template #footerRight>
        <agpr-button
            [id]="id + '-submitBtn'"
            label="Core.ghostIn.header"
            (click)="ghostIn()"
            [style]="buttonTypesEnum.primary"
            [disabled]="username.value.length === 0 || !ghostInForm.valid"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
